import React from 'react';
import { Card, List, ListItem, Button, Icon, Text } from '@mc/ui-v4';
import { mcFile, mcDownload, mcInfoFilled } from '@mc/react-ui-icons';
import { downloadDokumentSoubor, downloadDokumentZadostSoubor } from '../helpers/urls';
export const DokumentyCard = ({ extPripadId, zadostId, dokumenty }) => {
    var _a;
    const hasDokumenty = ((_a = dokumenty === null || dokumenty === void 0 ? void 0 : dokumenty.length) !== null && _a !== void 0 ? _a : 0) > 0;
    const downloadSingle = (dokumentId, download = true) => {
        if (zadostId) {
            downloadDokumentZadostSoubor(zadostId, dokumentId, download);
        }
        else if (extPripadId) {
            downloadDokumentSoubor(extPripadId, dokumentId, download);
        }
    };
    const downloadAll = () => {
        var _a;
        const ids = ((_a = dokumenty === null || dokumenty === void 0 ? void 0 : dokumenty.filter(d => d.id).map(d => d.id)) !== null && _a !== void 0 ? _a : []);
        if (zadostId) {
            downloadDokumentZadostSoubor(zadostId, ids);
        }
        else if (extPripadId) {
            downloadDokumentSoubor(extPripadId, ids);
        }
    };
    return (React.createElement(Card, { title: 'Dokumenty žádosti', mode: 'view', extra: hasDokumenty && (zadostId || extPripadId) ? (React.createElement(Button, { style: 'link', onClick: downloadAll }, "St\u00E1hnout v\u0161e")) : null, style: { border: '1px solid #d8e4f5' } }, hasDokumenty ? (React.createElement(List, null, dokumenty.map(dokument => (React.createElement(ListItem, { key: `dokument-${dokument.id}`, className: 'pr-1 py-0 dokument-list-item', bodyClassName: 'py-1', onClick: () => {
            if (dokument.id) {
                downloadSingle(dokument.id, false);
            }
        }, extra: React.createElement(Button, { style: 'link', icon: React.createElement(Icon, { icon: mcDownload }), onClick: e => {
                e.stopPropagation();
                if (dokument.id) {
                    downloadSingle(dokument.id);
                }
            }, showOnHover: true }) },
        React.createElement(Icon, { className: 'mr-1', icon: mcFile }),
        React.createElement("span", null, dokument.nazev)))))) : (React.createElement("div", { className: 'd-flex flex-column align-items-center p-3 text-center' },
        React.createElement(Icon, { icon: mcInfoFilled, intent: 'secondary', size: '2x', className: 'mb-1' }),
        React.createElement(Text, { style: { maxWidth: 128 } }, "K p\u0159\u00EDpadu se nevztahuj\u00ED \u017E\u00E1dn\u00E9 dokumenty.")))));
};
//# sourceMappingURL=DokumentyCard.js.map